import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'en-US', name: 'English', flag: '🇺🇸' },
  { code: 'es-ES', name: 'Español', flag: '🇪🇸' },
];

export default function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const [showLanguages, setShowLanguages] = useState(false);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleChangeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
    setShowLanguages(false);
    
    // Recarregar a página para aplicar todas as traduções
    window.location.reload();
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowLanguages(!showLanguages)}
        className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
        title={t('header.changeLanguage') || 'Alterar idioma'}
      >
        <span className="text-2xl">{currentLanguage.flag}</span>
        <span className="text-sm font-medium text-gray-700">{currentLanguage.name}</span>
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-gray-400"></i>
        </div>
      </button>

      {showLanguages && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          <div className="p-2">
            <div className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">
              {t('header.selectLanguage') || 'Selecione o idioma'}
            </div>
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleChangeLanguage(language.code)}
                className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                  language.code === currentLanguage.code
                    ? 'bg-blue-50 text-blue-600'
                    : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                <span className="text-2xl">{language.flag}</span>
                <span className="text-sm font-medium flex-1 text-left">{language.name}</span>
                {language.code === currentLanguage.code && (
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}